export default __webpack_public_path__ + "static/media/pic1.d3fa10b2.jpg";